import { useEffect, useState } from 'react';
import { Col, Row, Nav } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { DefaultTheme, useTheme } from 'styled-components';
import { toast } from 'react-toastify';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import { FiEdit3, FiTrash, FiTwitch } from 'react-icons/fi';
import { FaUserAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { Breadcrumb } from '../../components/Breadcrumb';
import { Button } from '../../components/Button';
import { IInfluencer } from '../../interfaces/IInfluencer';
import api from '../../services/api';
import { IPagination, Pagination } from '../../components/Pagination';
import { IGames } from '../../interfaces/IGames';
import { ContainerNav, Thumb, NoThumb } from './styles';
import thumbInfluencer from '../../assets/influencer.png';
import { Table } from '../../styles/components';

// const tools = [
//   {
//     name: 'Twitch',
//   },
//   {
//     name: 'Instagram',
//   },
//   {
//     name: 'Facebook',
//   },
//   {
//     name: 'Twitter',
//   },
//   {
//     name: 'Todos',
//   },
// ];

export const Influencers = () => {
  const location = useLocation();
  const history = useHistory();
  const theme: DefaultTheme = useTheme();
  const [influencers, setInfluencers] = useState<IInfluencer[]>([]);
  const [pagination, setPagination] = useState<IPagination>();
  const [games, setGames] = useState<IGames[]>([]);
  // const [checkedStateTools, setCheckedStateTools] = useState(
  //   new Array(tools.length).fill(false),
  // );

  useEffect(() => {
    api
      .get('/games')
      .then(({ data }) => {
        setGames(data);
      })
      .catch(() => toast.error('Erro ao buscar jogos'));

    api
      .get('/influencers')
      .then(({ data }) => {
        setInfluencers(data.data);
        setPagination({
          currentPage: data.meta.current_page,
          perPage: data.meta.per_page,
          total: data.meta.total,
        });
      })
      .catch(() => toast.error('Erro ao buscar influenciadores'));
  }, [location.search]);

  const filterInfluencers = (filters: any) => {
    api
      .get(`/influencers${filters === 'game=all' ? '' : `?${filters}`}`)
      .then(({ data }) => {
        setInfluencers(data.data);
        setPagination({
          currentPage: data.meta.current_page,
          perPage: data.meta.per_page,
          total: data.meta.total,
        });
      })
      .catch(() => toast.error('Erro ao buscar influenciadores'));
  };

  const handleSelect = (eventKey: any) => {
    filterInfluencers(`game=${eventKey}`);
  };

  // const handleOnChange = (position: number) => {
  //   const updatedCheckedState = checkedStateTools.map((item, index) =>
  //     index === position ? !item : item,
  //   );
  //   setCheckedStateTools(updatedCheckedState);
  // };

  const NavGames = () => {
    const navItemGames = games.map(item => (
      <Nav.Item>
        <Nav.Link eventKey={item.id} title={item.name}>
          {item.name}
        </Nav.Link>
      </Nav.Item>
    ));
    return <>{navItemGames}</>;
  };

  const handleRemoveInfluencer = (idInfluencer: number) => {
    Swal.fire({
      title: `<h4 style="color: ${theme.colors.textSecondary}">Você tem certeza?</h4>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: theme.colors.secondary,
      cancelButtonColor: theme.colors.textSecondary,
      cancelButtonText: 'Fechar',
      confirmButtonText: 'Sim, apagar!',
    }).then(async (result: { isConfirmed: any }) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`influencers/${idInfluencer}`);
          setInfluencers(old => [
            ...old.filter(item => item.id !== idInfluencer),
          ]);
          toast.success('Influenciador excluído com sucesso');
        } catch {
          toast.error('Erro ao excluir influenciador');
        }
      }
    });
  };

  const handleCopyToClipboard = (idInfluencer: number) => {
    const link = `https://id.twitch.tv/oauth2/authorize?response_type=token&client_id=${process.env.REACT_APP_TOKEN_TWITCH}&redirect_uri=${process.env.REACT_APP_URL_REDIRECT_TWITCH}&state=${idInfluencer}&scope=channel:read:subscriptions%20bits:read`;
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para área de transferência');
  };

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: 'Influenciadores',
          },
        ]}
      />

      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={19}>
          <h4>Gerenciar Influenciadores</h4>
        </Col>
        <Col md={2} xs={{ span: 3 }}>
          <Button
            type="button"
            background={theme.colors.secondary}
            color="#fff"
            onClick={() => history.push('/influencers/new')}
          >
            Novo
          </Button>
        </Col>
      </Row>
      {/* <Row className="d-flex align-items-center mt-4">
        <Col md={4} xs={4}>
          <h3>Ferramentas</h3>
          <ul className="toppings-list">
            {tools.map(({ name }, index) => (
              <li key={index}>
                <div className="toppings-list-item">
                  <div className="left-section">
                    <input
                      type="checkbox"
                      id={`custom-checkbox-${index}`}
                      name={name}
                      value={name}
                      checked={checkedStateTools[index]}
                      onChange={() => handleOnChange(index)}
                    />
                    <label htmlFor={`custom-checkbox-${index}`}>{name}</label>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
      </Row> */}

      {/* <ContainerNav>
        <Nav variant="pills" defaultActiveKey="all" onSelect={handleSelect}>
          <ScrollingCarousel>
            <Nav.Item>
              <Nav.Link eventKey="all" title="Todos">
                Todos
              </Nav.Link>
            </Nav.Item>
            <NavGames />
          </ScrollingCarousel>
        </Nav>
      </ContainerNav> */}

      <Row className="mt-2">
        <Col md={12}>
          <Table responsive>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              {influencers.map(item => (
                <tr key={item.id}>
                  <td className="d-flex align-items-center">
                    {item.thumb ? (
                      <Thumb>
                        <img
                          src={item?.thumb || thumbInfluencer}
                          alt={item.name}
                        />
                      </Thumb>
                    ) : (
                      <NoThumb>
                        <FaUserAlt />
                      </NoThumb>
                    )}
                    <h6 className="ml-1">{item.name}</h6>
                  </td>

                  <td>
                    <div>
                      {item.useTwitch === 1 && (
                        <button
                          type="button"
                          onClick={() => handleCopyToClipboard(item.id)}
                        >
                          <FiTwitch />
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() =>
                          history.push(`/influencers/${item.id}/report`)
                        }
                      >
                        <HiOutlineDocumentReport />
                      </button>
                      <button
                        type="button"
                        onClick={() => handleRemoveInfluencer(item.id)}
                      >
                        <FiTrash />
                      </button>
                      <button
                        type="button"
                        onClick={() => history.push(`/influencers/${item.id}`)}
                      >
                        <FiEdit3 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
        <Col md={12}>{pagination && <Pagination {...pagination} />}</Col>
      </Row>
    </div>
  );
};
